import { MESSAGE } from 'triple-beam';
import { format } from 'winston';
import { messageSymbol } from '../../utils.js';

/**
 * Prefix message if message is a simple string.
 */ const setPrefix = format((info, { prefix })=>{
    if (prefix && typeof info.message === 'string') {
        const prefixed = `${prefix}${info.message}`;
        info.message = prefixed;
        if (info[MESSAGE] != null) {
            info[MESSAGE] = messageSymbol(info);
        }
    }
    return info;
});

export { setPrefix };
//# sourceMappingURL=setPrefix.js.map
